module.exports = __webpack_public_path__ + "static/media/Salesforce.8cdcb941.jpeg";